import React, { useState, useEffect } from 'react';
import {
  NumberInput,
  required,
  SelectInput,
  useDataProvider,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin';
import { nonNegativeInt, validateFolderNumber } from 'utils/validation';
import { BaseForm } from '../../Components';
import { makeStyles } from '@material-ui/core/styles';

// Material-UI adds an extra div around AutoCompleteInput that sets a flex-grow: 1
// which pushing the component to the left. In order to disable need another wrapper to overwrite it
const useStyles = makeStyles({
  root: {
    flexGrow: 0,
  },
});
const nonNegativeIntValidation = [required(), nonNegativeInt];
const folderNumberValidation = [required(), validateFolderNumber];

const PlotEvidenceForm = (props) => {
  const [evidences, setEvidences] = useState([]);
  const dataProvider = useDataProvider();
  const autoCompleteStyle = useStyles();

  useEffect(() => {
    dataProvider
      .getList('evidence', {
        filter: { plotId: props.createRecord.plotId },
      })
      .then(({ data }) => {
        const evidenceArray = data.map(({ id, name }) => ({ id, name }));
        setEvidences(evidenceArray);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <BaseForm {...props}>
      {/* <SelectInput
        source="evidenceId"
        label="Evidence Name"
        choices={evidences}
        validate={required()}
      /> */}
      <div className={autoCompleteStyle.root}>
        <AutocompleteInput
          // className={form.column}
          source="evidenceId"
          choices={evidences}
          optionText="name"
          optionValue="id"
          shouldRenderSuggestions = {(val) =>  val.trim().length > 0 }
          validate={required()}
        />
      </div>
      <NumberInput source="folderNumber" validate={folderNumberValidation} />
      <NumberInput source="orderIndex" validate={nonNegativeIntValidation} />
      <NumberInput
        source="requiredActors"
        validate={nonNegativeIntValidation}
      />
    </BaseForm>
  );
};

export default PlotEvidenceForm;
